import React from 'react';
import { motion } from 'framer-motion';

const PhilosophySection = () => {
  const beliefs = [
    "Technology should strengthen people, not replace them.",
    "Leadership matters more than AI tools.",
    "Thriving organisations make thoughtful decisions about AI, they don't just adopt the most tools.",
    "Good AI implementation starts with people, values, and purpose.",
    "The goal isn't simply to use AI. The goal is to use AI well."
  ];

  return (
    <div className="mt-20">
      <h2 className="text-3xl font-bold text-brand-navy mb-10 text-center">What I believe</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {beliefs.map((belief, i) => (
          <motion.div 
            key={i}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-brand-navy p-8 rounded-[2rem] text-white flex items-center"
          >
            <p className="text-lg font-medium leading-relaxed italic">
              "{belief}"
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default PhilosophySection;